import useMarketedPromotions from 'bento-ordering/promotions/hooks/useMarketedPromotions';

function useShouldDisplayPromotionsOnCart() {
  const promotions = useMarketedPromotions();
  return promotions.length > 0;
}

export default useShouldDisplayPromotionsOnCart;
